import { unstable_batchedUpdates } from 'react-dom';

let pending: Array<() => void> | null = null;

const flush = () => {
  const updates = pending;
  pending = null;
  if (!updates) return;
  unstable_batchedUpdates(() => {
    updates.forEach(update => update());
  });
};

/**
 * Runs a media-query change handler's state update in one React commit together with every other
 * handler that fires in the same frame.
 *
 * MediaQueryList `change` events are dispatched one list at a time, outside React's event system,
 * so React 17 commits each listener's setState on its own. With a few hundred `useResponsive` /
 * `useMediaQuery` call sites, one breakpoint flip on the guest site was ~60 commits. The browser
 * evaluates media queries and then runs animation-frame callbacks within the same rendering
 * update, so a frame callback scheduled from the first change event runs after the last one and
 * before paint. Flushing there inside `unstable_batchedUpdates` makes the flip a single commit.
 */
export const scheduleMediaQueryUpdate = (update: () => void) => {
  if (pending) {
    pending.push(update);
    return;
  }
  pending = [update];
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(flush);
  } else {
    flush();
  }
};
